export const TEXT_KEYS = {
    EVENT_DATES_ONE_MONTH: 'content__event-dates__single-month',
    EVENT_DATES_TWO_MONTH: 'content__event-dates__two-month',
    EVENT_AVAILABLE: 'content__event-available',
    EVENT_PRELOAD_AVAILABLE: 'content__event-preload'
};
